// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","ScreenSMMin":"(min-width: 768px)","wrapperFloatCard":"Gdfaa50","card":"G512b80","smallScreensOnly":"Ge9f54e","isHidden":"G94475c"};